import React from 'react';
import { Circle, CheckCircle, XCircle } from 'lucide-react';

const StatusText = ({ status }) => {
  const getStatusContent = () => {
    switch(status) {
      case 'pass': return <><CheckCircle size={18} className="mr-2 text-green-500" /> Pass</>;
      case 'acceptable': return <><Circle size={18} className="mr-2 text-yellow-500" /> Acceptable</>;
      case 'fail': return <><XCircle size={18} className="mr-2 text-red-500" /> Fail</>;
      default: return '-';
    }
  };
  const getStatusColour = () => {
    switch(status) {
      case 'pass': return 'text-green-600 dark:text-green-400';
      case 'acceptable': return 'text-yellow-600 dark:text-yellow-400';
      case 'fail': return 'text-red-600 dark:text-red-400';
      default: return 'text-gray-500 dark:text-gray-500';
    }
  };
  return (
    <div className={`mt-2 text-md font-bold flex items-center justify-center ${getStatusColour()}`}>
      {getStatusContent()}
    </div>
  );
};


const StatusCard = ({ label, value, status }) => {
  const getCardColour = () => {
    switch(label) {
      case 'CI100': return 'bg-purple-100 dark:bg-purple-900/20 border-purple-300 dark:border-purple-900';
      case 'CI50': return 'bg-indigo-100 dark:bg-indigo-900/20 border-indigo-300 dark:border-indigo-900';
      default: return 'bg-gray-100 dark:bg-gray-800 border-gray-300 dark:border-gray-700';
    }
  };
  return (
    <div className={`${getCardColour()} rounded-xl p-4 md:p-6 shadow-md border transition-transform transform hover:scale-105 duration-200`}>
      <h3 className="text-md text-gray-700 dark:text-gray-300 font-semibold mb-2 text-center">{label}</h3>
      <p className="text-xl md:text-2xl font-bold text-gray-900 dark:text-cyan-400 text-center">{value}</p>
      <StatusText status={status} />
    </div>
  );
};

export default StatusCard;